// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swal2-container {
    z-index: 99999 !important;
  }
  
  .swal2-toast-popup {
    color: #fff;
    font-size: 12px;
    width: 300px !important;
    padding-bottom: 2px;
    margin-right: 8px;
  }

  .swal2-html-container {
    padding: 5px !important;
  }

  .swal2-popup:hover {
    box-shadow: 0 0 12px #999;
  }

  .toast-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 0px;
  }

  .success-container {
    background-color: #51a351;
  }

  .error-container {
    background-color: #bd362f;
    color: #fff;
  }

  .info-container {
    background-color: #2f96b4;
  }

  .warning-container {
    background-color: #f89406;
  }

  .swal2-toast-icon {
    margin: 15px auto 0 !important;
    font-size: 8px !important;
  }

  .swal2-actions {
    margin: 0px auto auto !important;
    margin-bottom: 10px !important;
  }

  .error-btn {
    background: #f5f5f5;
    color: black;
    font-size: 14px;
    font-weight: 500;
  }`, "",{"version":3,"sources":["webpack://./src/utils/notification-manager.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,gCAAgC;IAChC,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB","sourcesContent":[".swal2-container {\n    z-index: 99999 !important;\n  }\n  \n  .swal2-toast-popup {\n    color: #fff;\n    font-size: 12px;\n    width: 300px !important;\n    padding-bottom: 2px;\n    margin-right: 8px;\n  }\n\n  .swal2-html-container {\n    padding: 5px !important;\n  }\n\n  .swal2-popup:hover {\n    box-shadow: 0 0 12px #999;\n  }\n\n  .toast-content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    padding: 0px;\n  }\n\n  .success-container {\n    background-color: #51a351;\n  }\n\n  .error-container {\n    background-color: #bd362f;\n    color: #fff;\n  }\n\n  .info-container {\n    background-color: #2f96b4;\n  }\n\n  .warning-container {\n    background-color: #f89406;\n  }\n\n  .swal2-toast-icon {\n    margin: 15px auto 0 !important;\n    font-size: 8px !important;\n  }\n\n  .swal2-actions {\n    margin: 0px auto auto !important;\n    margin-bottom: 10px !important;\n  }\n\n  .error-btn {\n    background: #f5f5f5;\n    color: black;\n    font-size: 14px;\n    font-weight: 500;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
